import { Lang } from '../../Lang';
import { FormGroup2, FormRow2, LangTextV2, ModalDialog2, ModalDialogType2, Textarea2 } from 'bambooo';
/**
 * Sighting deleted modal dialog.
 */
export class SightingDeletedModal extends ModalDialog2 {
    /**
     * Constructor from Dialog.
     */
    constructor() {
        super({ id: 'sightingdeletemodaldialog', modalType: ModalDialogType2.large });
        /**
         * ID of entry.
         * @member {number|null}
         */
        this._sightingId = null;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const rowFirst = new FormRow2({});
        rowFirst.appendTo(bodyCard);
        const groupDesc = new FormGroup2({
            label: new LangTextV2({ text: 'Are you sure you want to delete the sighting? Please describe:' })
        });
        groupDesc.appendTo(rowFirst.createCol(6));
        this._descriptionArea = new Textarea2({});
        this._descriptionArea.appendTo(groupDesc);
        // buttons -----------------------------------------------------------------------------------------------------
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * getSightingId
     */
    getSightingId() {
        return this._sightingId;
    }
    /**
     * Set the ID of entry.
     * @param {number|null} id - ID of entry.
     */
    setSightingId(id) {
        this._sightingId = id;
    }
    /**
     * Return the description by textarea input.
     * @returns {string}
     */
    getDescription() {
        return this._descriptionArea.getValue();
    }
    /**
     * Set the description to textarea.
     * @param {string} description
     */
    setDescription(description) {
        this._descriptionArea.setValue(description);
    }
    /**
     * resetValues
     */
    resetValues() {
        this.setSightingId(null);
        this.setDescription('');
    }
}
